import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Table } from "antd";
import editIcon from "../../../Assets/Images/edit-icon.svg";
import deleteIcon from "../../../Assets/Images/delete-icon.svg";
import { participantServices } from "../../../Services/API/participantsServices";
import Loader from "../../../Components/Loader/Loader";
import { toast } from "react-toastify";
import tableCellRender from "../../../Components/TableCellRender/tableCellRender";
import AlertModal from "../../../Components/AlertModal/AlertModal";

export default function Participants() {
  const navigate = useNavigate();
  const windowWidth = window.innerWidth;
  const [participants, setParticipants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [participantToDelete, setParticipantToDelete] = useState(null);

  const showDeleteModal = (participant) => {
    setParticipantToDelete(participant);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setParticipantToDelete(null);
  };

  const handleConfirmDelete = () => {
    if (participantToDelete) {
      const idWithoutQuotes = participantToDelete?.id?.replace(/"/g, "");
      const encodedId = encodeURIComponent(idWithoutQuotes);
      participantServices
        .deleteParticipant(encodedId)
        .then((response) => {
          toast.success("Participant deleted");
          fetchParticipants();
          setIsModalVisible(false);
          setParticipantToDelete(null);
        })
        .catch((error) => {
          toast.error(error?.response?.data || "Error deleting Participant!");
          console.log(error);
          setIsModalVisible(false);
          setParticipantToDelete(null);
        });
    }
  };

  const fetchParticipants = () => {
    setLoading(true);
    participantServices
      .getAllParticipants()
      .then((response) => {
        setParticipants(response?.data);
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error?.response?.data || "error fetching participants");
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchParticipants();
  }, []);

  const columns = [
    {
      title: "First Name",
      dataIndex: "participant_first_name",
      key: "participant_first_name",
      fixed: "left",
      width: windowWidth > 1024 ? 250 : 200,
      sorter: (a, b) =>
        a?.participant_first_name.localeCompare(b?.participant_first_name),
      render: (value) => tableCellRender(value, "single-val"),
    },
    {
      title: "Last Name",
      dataIndex: "participant_last_name",
      key: "participant_last_name",
      width: windowWidth > 1024 ? 250 : 200,
      sorter: (a, b) =>
        a?.participant_last_name.localeCompare(b?.participant_last_name),
      render: (value) => tableCellRender(value, "single-val"),
    },
    {
      title: "Phone Number",
      dataIndex: "participant_phone_number",
      key: "participant_phone_number",
      width: windowWidth > 1024 ? 300 : 200,
      render: (value) => tableCellRender(value, "single-val"),
    },
    {
      title: "Email ID",
      dataIndex: "participant_email",
      key: "participant_email",
      render: (value) => tableCellRender(value, "single-val"),
    },
    {
      title: " ",
      dataIndex: "",
      key: "",
      width: 120,
      render: (value) => {
        return (
          <div className="actions-div">
            <div className="edit-fundraiser-container">
              <img
                className="actions-icons"
                src={editIcon}
                alt="Edit Participant"
                onClick={() =>
                  navigate("/participants", {
                    state: { action: "edit", data: value },
                  })
                }
              />
            </div>
            <div
              className="delete-fundraiser-container"
              onClick={() => showDeleteModal(value)}
            >
              <img
                className="actions-icons"
                src={deleteIcon}
                alt="Delete Participant"
              />
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div className="listing-page">
      <div className="listing-header-container">
        <div className="heading">Participants</div>
        <div className="add-btn-container">
          <Button
            className="add-btn"
            onClick={() =>
              navigate("/participants", { state: { action: "add", data: "" } })
            }
          >
            Add New Participant
          </Button>
        </div>
      </div>
      <div className="table-container">
        {loading ? (
          <Loader />
        ) : (
          <Table
            className="table-class"
            columns={columns}
            dataSource={participants}
            scroll={{
              x: "auto",
            }}
          />
        )}
      </div>
      {isModalVisible && (
        <AlertModal
          openModal={isModalVisible}
          closeModal={handleCancel}
          handleYes={handleConfirmDelete}
          title={"participant"}
        />
      )}
    </div>
  );
}
